<template>
  <div>
    <div class="box_top">
      <div class="el-icon-s-home">当前位置：</div>
        <el-breadcrumb separator=">>">
          <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>搜索</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="search-result" v-if="searchlists.length!==0">
        <ul v-for="(item,index) in searchlists" :key="index" @click="btn(item)">
          <li class="search-title">{{ item.title }}</li>
          <li class="search-content" v-html="item.intro"></li>
          <li class="search-date">{{ item.createdTime }}</li>
        </ul>
      </div>
      <div v-else class="none_box">
        暂无数据
      </div>
      <!-- 分页 -->
      <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNo"
      :page-sizes="[5, 10, 15, 20]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
      </el-pagination>
  </div>
</template>

<script>
export default{
  data(){
    return {
      searchlists: [],
      // 查询的参数
      queryInfo:{
        // 当前是第几页
        pageNo:1,
        // 当前显示多少条数据
        pageSize:20
      },
      // 搜索框里面的值
      keyword:'',
      // 总共多少条数据
      total:400,
    }
  },
  mounted(){
    this.keyword=this.$route.query.query
    this.getSearchlists()
  },
  watch:{
   //监听路由地址的改变
    $route:{
      // immediate:true,
      handler(){
        if(this.$route.query.query){//需要监听的参数
            this.keyword = this.$route.query.query
            this.$nextTick(()=>{
              this.getSearchlists()
            })
        }
      }
    }
  },
  methods:{
    // 处理数据的方法
    ellipsis(value){
      if (!value) return '';
      if (value.length > 120) {
        return value.slice(0,120) + '......'
      }
      return value
    },
    // 获取搜索列表数据
    async getSearchlists(){
      const {data:res}=await this.$http.get(`/article/search?pageNo=${this.queryInfo.pageNo}&pageSize=${this.queryInfo.pageSize}&keyword=${this.keyword}`)
      if(res.code==200){
        res.data.lists.forEach(item => {
          item.intro=this.ellipsis(item.intro)
        });
        this.searchlists=res.data.lists
        this.total=res.data.count
      }
    },
    //一页显示多少条变化的函数
    handleSizeChange(newSize){
      this.queryInfo.pageSize=newSize
      this.getSearchlists()
    },
    // 第几页的变化
    handleCurrentChange(newPage){
      this.queryInfo.pageNo=newPage
      this.getSearchlists()
    },
    // 点击每一条文章触发的函数
    btn(item){
      this.$router.push({path:'/maintext',query:{id:item.id}})
    }
  }
}
</script>

<style lang="less" scoped>
  .box_top{
    height: 46px;
    border-bottom: 1px solid #edebea;
    margin-top: 15px;
    line-height: 46px;
    display: flex;
    align-items: center;
    div{
        font-size: 14px;
        color: #666;
    }
    .el-breadcrumb{
        margin-left: 10px;
        font-size: 14px;
        color: #666;
    }
}
.search-result{
  ul{
    border-bottom: 1px solid #ccc;
  }
  ul li{
    list-style: none;
    cursor: pointer;
  }
  .search-title{
    font-size: 18px!important;
    padding-bottom: 10px;
    font-weight: bold;
  }
  .search-content{
    // height: 70px;
    font-size: 15px!important;
    line-height: 28px;
    text-indent: 2em;
    margin-bottom: 10px;
    text-overflow:ellipsis; //设置超出部分显示...
	  -o-text-overflow:ellipsis;//浏览器兼容
	  overflow: hidden; //超出部分不显示
    ::v-deep img{
      display: none;
    }
  }
  .search-date{
    font-size: 14px;
    color: #2B802B;
    padding-bottom: 20px;
  }
}
.none_box{
  width: 100%;
  height: 100px;
  text-align: center;
  line-height: 100px;
}
</style>